import React from "react";
import { Link } from "react-router-dom";
import { prductData } from "../Data";
import { AiOutlineCheckSquare } from "react-icons/ai";

function OurProduct() {
  return (
    <section className=" py-10 px-12 w-[90%] mx-auto">
      <div className="grid grid-flow-row gap-x-20 gap-y-10 text-neutral-600 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
        {prductData.map((post, index) => (
          <div
            key={index}
            className="my-8 rounded shadow-lg shadow-gray-200 bg-[#F8F8F8] p-2 duration-300 hover:-translate-y-1 relative flex flex-col justify-between"
          >
            <figure>
              <div className="flex items-center justify-center ">
                <img
                  src={`${post.image}?auto=format&fit=crop&w=400&q=50`}
                  className="rounded-full h-[100px] w-[100px] object-cover absolute top-[-50px]  transition-transform transform scale-100 rotate-0 hover:scale-125 hover:rotate-45"
                  alt={post.title}
                />
              </div>
              <figcaption className="p-4 mt-12 text-center">
                <p className="text-lg mb-4 font-bold leading-relaxed text-gray-800">
                  {post.title}
                </p>
                <small className="leading-5 text-gray-500">
                  {post.description}
                </small>
              </figcaption>
            </figure>
            <div className="flex items-center justify-center my-3">
              <Link to={`/product/${post.id}`}>
                <span
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="inline-block rounded-full bg-primary px-6 pt-2.5 pb-2 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg_primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                >
                  Read more
                </span>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}


const items = [
  [
    "Vacuum gauge",
    "Digital Vacuum Gauge",
    "Pressure Gauge",
    "Pressure Transmitter",
    "Compound gauge",
    "Vacuum Transmitter",
    "Pressure Transducer",
  ],
  [
    "Vacuum Transducer",
    "Pressure Recorder",
    "Digital Pressure Gauge",
    "Safety Valve",
    "Pressure Controller",
  ],
];

const PressureAndVacuum = () => {
  return (
    <section className="py-8 px-4">
      <h2 className="text-2xl md:text-3xl font-bold text-center text-teal-700 mb-8">
      Dimension Instruments
      </h2>
      <div className="flex flex-col md:flex-row gap-2 md:gap-10 justify-around	">
        {items.map((column, index) => (
          <ul key={index} className="space-y-3">
            {column.map((item, idx) => (
              <li
                key={idx}
                className="flex items-center text-sm md:text-base text-gray-800"
              >
                <AiOutlineCheckSquare className="text-teal-600 mr-2" />
                {item}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </section>
  );
};


const Services = () => {
  return (
    <div>
      <div
        className="h-[20rem] bg-cover relative bg-center flex items-center justify-start text-white"
        style={{
          backgroundImage: 'url("./img/product.jpeg")',
        }}
      >
        <h1 className="text-5xl font-bold text-white absolute top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28">
        Services
        </h1>
      </div>
      {/* <div className="text-center w-[60%] m-auto py-3  font-teko my-10">
        <h5 className="text-blue-600 text-2xl font-[700] ">Our Services</h5>
        <h6 className="text-2xl md:text-4xl font-[800] mt-10">
          We Focused On Modern Product
        </h6>
      </div> */}
      {/* {PressureAndVacuum()} */}
      {InstrumentCategories()}
    </div>
  );
};

export default Services;

const data = [
  {
    category: "Electro-Technical",
    items: [
      "Universal Calibrators / Multifunction Calibrator",
      "Up to 6 ½ Digit Digital Multimeters",
      "Clamp on meters (3500A AC & 1000A DC)",
      "High Voltage Breakdown testers (100kV AC/DC)",
      "Power / PF Meters",
      "Power Analyzers",
      "Power Quality meters",
      "Signal Generators",
      "Frequency Counters",
      "Resistance, Capacitance, Inductance - Decade box",
      "LCR Meters & Bridges",
      "Insulation testers",
      "Temp. Controller / Indicator / Scanner",
      "Digital / Analog Ammeter",
      "Data Acquisition System",
      "Data loggers",
      "Oscilloscope",
      "Digital / Analog Voltmeter",
      "Hipot Testers",
      "Micro Ohm Meter",
      "Battery Testers",
      "Current Source",
      "Voltage Source",
      "HV Probes AC/DC (100kV AC/DC)",
      "HV Divider AC/DC (100kV AC/DC)",
      "Std. CT (Up to 6000 AC @ class 0.05)",
      "Std PT (Up to 33 kV)",
      "CT Burden Box",
      "PT Burden Box",
      "Timer / Time Interval Meter",
      "V, I & R Calibrator",
      "Earth testers",
      "VAW Meter",
      "PH Meter (By Simulation Method)",
      "Loop Calibrator",
      "Energy Meter",
    ],
  },
  {
    category: "Dimensions",
    items: [
      "Calliper (Vernier/Dial/Digital)",
      "Depth Gauge (Vernier/Dial/Digital)",
      "Height Gauge (Vernier/Dial/Digital)",
      "External Micrometer",
      "Depth Micrometer",
      "Internal Micrometer",
      "Dial Gauge (Plunger Type)",
      "Dial Gauge (Lever Type)",
      "Bore Gauge",
      "Dial Snap Gauge",
      "Inside Dial Calliper",
      "Dial Thickness Gauge",
      "Bevel Protector",
      "Plain Plug Gauge / OD Master / Height / Width / Flush Pin Gauge",
      "Thread Plug Gauge Taper Thread Plug",
      "Snap Gauge",
      "Feeler Gauge Set / Thickness Foils",
      "Measuring Pin / Thread Measuring Wire",
      "Engineering Square",
      "Angle Plate / Box Angle",
      "Comparator with Stand / Electronic Probe with DRO / Comparator",
      "Flatness of Base Snap Gauge",
      "Coating Thickness Gauge",
      "Thread Ring Gauge",
      "Plain Ring Gauge",
      "Slip Gauges Sets",
      "Radius Gauge",
      "Thread Pitch Gauge",
      "Measuring Tape",
      "Measuring Scale",
      "Scale / Tape Calibrator",
      "ULM",
      "Surface Plate",
      "Linear Height Measuring Instrument",
      "Profile Projector / Video Measuring System",
      "Micrometer Setting Stick / Length Bar",
      "V Block",
    ],
  },

  // {
  //   category: "Force & Hardness",
  //   items: [
  //     "Load cells with Indicator",
  //     "Universal Testing Machines",
  //     "Spring Testing Machines",
  //     "Compression & Tension Testing",
  //   ],
  // },
  {
    category: "Pressure",
    items: [
      "Vacuum Gauge / Transmitter (-1 to 0 bar)",
      "Pressure Gauge / Transmitter (Pneumatic) 0 to 40 bar",
      "Pressure Switch",
      "Magnehelic Gauge",
      "Pressure Gauge / Transmitter (Hydraulic) 0 to 1000 bar",
    ],
  },
  {
    category: "Mass & Volume",
    items: [
      "Std. Weights",
      "Weighing Balance (Up to 500 kg)",
      "Glassware",
      "Volumetric Flask",
      "Burette",
      "Conical Flask",
      "Glass Pipette",
      "Micropipette",
      "Measuring Cylinder",
    ],
  },

  {
    category: "Thermal",
    items: [
      "Humidity Calibrator (Single Point)",
      "Humidity Generator (Single Point)",
      "Temp. & Humidity Chamber (Single Point)",
      "Temp. & Humidity Chamber (Multi Points Mapping)",
      "Thermo Hygrometer",
      "RH Sensor with Indicator",
      "Dry Block Furnace (Single Point / Multi Points)",
      "Freezer (Single Point / Multi Points Mapping)",
      "Oven (Single Point / Multi Points Mapping)",
      "Glass, Dial Thermometer",
      "Incubator (Single Point / Multi Points Mapping)",
      "Furnace (Single Point / Multi Points Mapping)",
      "Environmental (Single Point / Multi Points Mapping)",
      "Chamber, BOD (Single Point / Multi Points Mapping)",
      "Incubator (Single Point / Multi Points Mapping)",
      "Liquid Bath (Single Point / Multi Points Mapping)",
      "Dry Block (Single Point)",
      "RTD Sensor",
      "PRT Sensor",
      "Thermocouple",
      "Temp. Transmitter with or without Indicator",
    ],
  },
];

const InstrumentCategories = () => {
  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-teal-700 mb-12">Instrument List</h2>

        {data.map((category, idx) => (
          <div key={idx} className="mb-16">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-semibold text-gray-800 inline-block px-6 py-2 border-b-4 border-teal-500">
                {category.category}
              </h3>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-6">
              {category.items.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300 p-6 border border-gray-200 text-center text-black text-md font-medium flex items-center justify-center min-h-[100px]"
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {ForceAndHardness()}
    </section>
  );
};


const forceAndHardnessData = [
  {
    title: "FORCE",
    entries: [
      {
        parameter: "Verification of Uniaxial Testing Machine ( UTM/CTM/TTM )",
        range: "0 N to 1000 KN",
      },
      {
        parameter: "Push Pull Meter / Load Cell",
        range: "0 Newton to 2000 Newton",
      },
      {
        parameter: "Verification of Displacement",
        range: "Upto 600 mm",
      },
      {
        parameter: "Verification of speed of Material Testing Machines",
        range: "Upto 600 mm/min",
      },
      {
        parameter: "Test Force Verification of Rockwell Hardness Tester",
        range: "3,10,15,30,45,60,100 & 150 Kgf",
      },
      {
        parameter: "Test Force Verification of Brinell Hardness Tester",
        range: "31.25,62.5,187.5,250, 500,750,1000,1500 & 3000 kgf",
      },
      {
        parameter: "Test Force Verification of Vickers Hardness Tester",
        range: "1,5,10,20,30 & 50 kgf",
      },
    ],
  },
  {
    title: "HARDNESS",
    entries: [
      {
        parameter: "Verification of Rockwell Hardness Tester by Indirect Method",
        range: "20 to 95 HRA\n20 to 100 HRBW\n20 to 70 HRC",
      },
      {
        parameter: "Verification of Brinell Hardness Tester by Indirect Method",
        range:
          "100 to 600 HBW 2.5 / 187.5\n100 to 600 HBW 5 / 750\n100 to 600 HBW 10/3000",
      },
      {
        parameter: "Verification of Vickers Hardness Tester by Indirect Method",
        range: "HV 1\nHV 5\nHV 10\nHV 20\nHV 30\nHV 50",
      },
    ],
  },
  {
    title: "IMPACT",
    entries: [
      {
        parameter: "Verification of Impact Testing Machine",
        range: "Upto 300 J",
      },
    ],
  },
  {
    title: "EXTENSOMETER",
    entries: [
      {
        parameter: "Verification of class 1 Extensometer",
        range: "1) Mechanical\n2) Electronic",
      },
    ],
  },
];

const ForceAndHardness = () => {
  return (
    <section className="py-12 px-4 bg-gray-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-teal-700 mb-12">
          Force & Hardness Instruments
        </h2>

        {forceAndHardnessData.map((section, idx) => (
          <div key={idx} className="mb-12">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-semibold text-gray-800 inline-block px-6 py-2 border-b-4 border-teal-500">
                {section.title}
              </h3>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full bg-white shadow-md rounded-xl overflow-hidden">
                <thead className="bg-teal-600 text-white">
                  <tr>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">
                      Sr No
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">
                      Parameter / Measured Quantity / Device Under Calibration
                    </th>
                    <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">
                      Range
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-700">
                  {section.entries.map((entry, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-50 border-b border-gray-200"
                    >
                      <td className="px-4 sm:px-6 py-3 whitespace-nowrap text-xs sm:text-sm">
                        {index + 1}
                      </td>
                      <td className="px-4 sm:px-6 py-3 whitespace-pre-wrap text-xs sm:text-sm">
                        {entry.parameter}
                      </td>
                      <td className="px-4 sm:px-6 py-3 whitespace-pre-wrap text-xs sm:text-sm">
                        {entry.range}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

